export default __webpack_public_path__ + "static/media/b135f2770e8c090bd611079f9ec3ae59.svg";